const UserListing = () => import("@/views/user/UserListing");
const UserCreate = () => import("@/views/user/UserCreate");
export const UserListingRoute = {
    path: "/users",
    component: UserListing,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",
        breadcrumb: [
            {
                text: "Usuarios",
                disabled: true,
                href: "#"
            },
            {
                text: "Consulta",
                disabled: false,
                href: "#"
            }
        ],
        scope:["aps_admin"]
    }
};
export const UserCreateRoute = {
    path: "/createUser",
    component: UserCreate,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",
        backState: "users",
        breadcrumb: [ 
            {
                text: "Usuarios",
                disabled: false,
                href: "UserListingRoute"
            },
            {
                text: "Crear",
                disabled: true,
                href: "#"
            }
        ],
        scope:["aps_admin"]
    }
};